import { BrowserRouter, Routes, Route } from "react-router";
import Layout from "@/components/layout";
import LoginPage from "@/app/login";
import ForgotPasswordPage from "@/app/forgot-password";
import ResetPasswordPage from "@/app/reset-password";
import RegistrationPage from "@/app/registration";
import RootPage from "@/app/root";
import NotFoundPage from "@/app/not-found";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import LightingPage from "./lighting";
import TemperaturePage from "./temperature";
import NoiseDosePage from "./noise_dose";
import ProfilePage from "./profile";
import HelpPage from "./help";
import BillingPage from "./billing";
import ReportsPage from "./reports";
import ConfigurationPage from "./configuration";
import EquipmentPage from "./equipment";
import CreateEquipmentPage from "./equipment/create";
import EditEquipmentPage from "./equipment/id/edit";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import EquipmentDetailsPage from "./equipment/id";
import VerifyEmailPage from "./verifica-correo";
import MergePdfsPage from "./merge-pdfs";
import DeleteAccountPage from "./delete-account";
import ReportDetailsPage from "./reports/id";
import ExtractDataPage from "./data-entry";
import LayoutsPage from "./layouts";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <BrowserRouter>
        <Routes>
          <Route path="/inicia-sesion" element={<LoginPage />} />
          <Route
            path="/recuperar-contrasena"
            element={<ForgotPasswordPage />}
          />
          <Route path="/resetear-contrasena" element={<ResetPasswordPage />} />
          <Route path="/registracion" element={<RegistrationPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<RootPage />} />
            <Route path="/eliminar-cuenta" element={<DeleteAccountPage />} />
            <Route path="/capturar-datos" element={<ExtractDataPage />} />
            <Route path="/ruido-dosis" element={<NoiseDosePage />} />
            <Route path="/iluminacion" element={<LightingPage />} />
            <Route path="/temperatura" element={<TemperaturePage />} />
            <Route path="/unir-pdfs" element={<MergePdfsPage />} />
            <Route path="/layouts" element={<LayoutsPage />} />
            <Route path="/ayuda" element={<HelpPage />} />
            <Route path="/equipos" element={<EquipmentPage />} />
            <Route path="/equipos/crear" element={<CreateEquipmentPage />} />
            <Route path="/equipos/:id" element={<EquipmentDetailsPage />} />
            <Route path="/equipos/:id/editar" element={<EditEquipmentPage />} />
            <Route path="/configuracion" element={<ConfigurationPage />} />
            <Route path="/reportes" element={<ReportsPage />} />
            <Route path="/reportes/:id" element={<ReportDetailsPage />} />
            <Route path="/facturacion" element={<BillingPage />} />
            <Route path="/perfil" element={<ProfilePage />} />
            <Route path="/verifica-correo" element={<VerifyEmailPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" closeButton />
    </QueryClientProvider>
  );
}

export default App;
